import Vue from 'vue'
import Chart from './chart'

if (document.getElementById('chart')) {
  new Vue({
    el: '#chart',
    render: createElement => createElement(Chart),
    created: function () {
      this.targetCode = window.targetCode,
      this.sourceCode = window.sourceCode,
      this.amount = document.getElementsByClassName("component-chart")[0].getAttribute(':data-amount')
    }
  })
}
